/**
 * PresentationLauncher — opens the /present surface for a milestone (Round 10).
 *
 * Mounted once in OutlineView. Listens for the outline's `open-presentation`
 * CustomEvent (dispatched by the milestone ⋯ "Open presentation" item), resolves
 * the linked Project Concepts record + presentation type via the service layer,
 * and opens /present in a new tab (team edit/present), matching the share/sketch
 * full-screen pattern. Renders nothing.
 */

import { useEffect, useRef } from 'react'
import { getPresentationByMilestone } from '../services/presentations'
import { alertDialog } from './Dialog.jsx'

export default function PresentationLauncher() {
  const busy = useRef(false)

  useEffect(() => {
    async function onOpen(e) {
      const msId = e?.detail?.msId
      if (!msId || busy.current) return
      busy.current = true
      try {
        const res = await getPresentationByMilestone(msId)
        if (res && res.recordId) {
          const url = '/present?recordId=' + encodeURIComponent(res.recordId) + '&type=' + encodeURIComponent(res.type)
          window.open(url, '_blank', 'noopener')
        } else {
          alertDialog({ title: 'Nothing to present', message: 'No design concept is linked to this project yet, so there is nothing to present.' })
        }
      } catch (err) {
        alertDialog({ title: 'Could not open the presentation', message: err.message || String(err) })
      } finally {
        busy.current = false
      }
    }
    window.addEventListener('open-presentation', onOpen)
    return () => window.removeEventListener('open-presentation', onOpen)
  }, [])

  return null
}
